export default __webpack_public_path__ + "static/media/ic-current-streak.00947f8d.svg";